import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Twitter: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] text-white', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.55016 21.7503C16.6045 21.7503 21.5583 14.247 21.5583 7.74217C21.5583 7.53123 21.5536 7.3156 21.5442 7.10467C22.5079 6.40777 23.3395 5.54456 24 4.5556C23.1025 4.95491 22.1496 5.21569 21.1739 5.32904C22.2013 4.71321 22.9705 3.74578 23.3391 2.60607C22.3726 3.17886 21.3156 3.58292 20.2134 3.80092C19.4708 3.01187 18.489 2.48942 17.4197 2.31436C16.3504 2.13929 15.2532 2.32136 14.2977 2.8324C13.3423 3.34345 12.5818 4.15501 12.1338 5.14162C11.6859 6.12822 11.5754 7.23492 11.8195 8.2906C9.86249 8.1924 7.94794 7.68401 6.19998 6.7984C4.45203 5.9128 2.90969 4.66974 1.67297 3.14982C1.0444 4.23355 0.852057 5.51595 1.13503 6.7364C1.418 7.95684 2.15506 9.02375 3.19641 9.72029C2.41463 9.69547 1.64998 9.48499 0.965625 9.10623V9.16717C0.964925 10.3045 1.3581 11.4069 2.07831 12.2871C2.79852 13.1673 3.80132 13.7709 4.91625 13.9953C4.19206 14.1934 3.43198 14.2223 2.69484 14.0797C3.00945 15.0577 3.62157 15.9132 4.44577 16.5266C5.26997 17.1401 6.26512 17.4809 7.29234 17.5015C5.54842 18.8714 3.39417 19.6144 1.17656 19.6109C0.783287 19.6103 0.390399 19.5862 0 19.5387C2.25286 20.9841 4.87353 21.7517 7.55016 21.7503Z"
      fill="currentColor"
    />
  </svg>
);

export default Twitter;
